// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-Footer----footer-module---container---eLTZU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/footer.module.less
// module id = 261
// module chunks = 114276838955818